/**
 * Port von `Components/Util/IwmLoadingIndicator.razor`.
 *
 * Die Klasse heißt im Altclient `container`; wegen der Kollision mit Bootstrap wird sie zu
 * `iwm-loading-container` umbenannt (REQ-08 §7, Regeln in `styles/components/_loading.scss`).
 */

import type { ReactElement } from 'react';

import { Spinner } from '@/components/ui';

export function LoadingIndicator(): ReactElement {
  return (
    <div className="iwm-loading-container">
      <Spinner visible />
    </div>
  );
}

export default LoadingIndicator;
